declare namespace $ {

	type $mol_string__hint_bog_vmap_app_inspect_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__enabled_bog_vmap_app_inspect_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['renamable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__value_bog_vmap_app_inspect_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['title_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_vmap_app_inspect_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['title_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_bog_vmap_app_inspect_5 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $bog_vmap_app_inspect['title_submit'] > ): ReturnType< $bog_vmap_app_inspect['title_submit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_status__status_bog_vmap_app_inspect_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['title_note'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_list__rows_bog_vmap_app_inspect_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_expander__title_bog_vmap_app_inspect_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__expanded_bog_vmap_app_inspect_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['shares_shown'] >
		,
		ReturnType< $mol_expander['expanded'] >
	>
	type $mol_expander__content_bog_vmap_app_inspect_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['share_rows'] >
		,
		ReturnType< $mol_expander['content'] >
	>
	type $bog_vmap_app_inspect_flex__value_bog_vmap_app_inspect_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['flex_value'] >
		,
		ReturnType< $bog_vmap_app_inspect_flex['value'] >
	>
	type $bog_vmap_app_inspect_flex__editable_bog_vmap_app_inspect_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_flex['editable'] >
	>
	type $mol_expander__title_bog_vmap_app_inspect_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__expanded_bog_vmap_app_inspect_14 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['layout_shown'] >
		,
		ReturnType< $mol_expander['expanded'] >
	>
	type $mol_expander__content_bog_vmap_app_inspect_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_expander__title_bog_vmap_app_inspect_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__expanded_bog_vmap_app_inspect_17 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['inherited_shown'] >
		,
		ReturnType< $mol_expander['expanded'] >
	>
	type $mol_expander__content_bog_vmap_app_inspect_18 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['inherited_rows'] >
		,
		ReturnType< $mol_expander['content'] >
	>
	type $bog_vmap_app_inspect_value__tree_bog_vmap_app_inspect_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['share_value'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['tree'] >
	>
	type $bog_vmap_app_inspect_value__binds_bog_vmap_app_inspect_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['binds'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['binds'] >
	>
	type $bog_vmap_app_inspect_value__nodes_bog_vmap_app_inspect_21 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['nodes'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['nodes'] >
	>
	type $bog_vmap_app_inspect_value__editable_bog_vmap_app_inspect_22 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_value['editable'] >
	>
	type $mol_select__hint_bog_vmap_app_inspect_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__enabled_bog_vmap_app_inspect_24 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['editable'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__value_bog_vmap_app_inspect_25 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['base'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_vmap_app_inspect_26 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['bases'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_bog_vmap_app_inspect_27 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['base_titles'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__filter_hint_bog_vmap_app_inspect_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['filter_hint'] >
	>
	type $mol_select__submit_bog_vmap_app_inspect_29 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['base_submit'] >
		,
		ReturnType< $mol_select['submit'] >
	>
	type $mol_status__status_bog_vmap_app_inspect_30 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['empty_note'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $bog_vmap_lang_node__source_bog_vmap_app_inspect_31 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['source'] >
		,
		ReturnType< $bog_vmap_lang_node['source'] >
	>
	type $bog_vmap_lib__pack_bog_vmap_app_inspect_32 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['pack'] >
		,
		ReturnType< $bog_vmap_lib['pack'] >
	>
	type $bog_vmap_lib__classes_bog_vmap_app_inspect_33 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['classes'] >
		,
		ReturnType< $bog_vmap_lib['classes'] >
	>
	type $mol_form_field__name_bog_vmap_app_inspect_34 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['share_row_name'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bids_bog_vmap_app_inspect_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['bids'] >
	>
	type $mol_form_field__control_bog_vmap_app_inspect_36 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['Share_value'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $bog_vmap_app_inspect_row__sign_bog_vmap_app_inspect_37 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['row_sign'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['sign'] >
	>
	type $bog_vmap_app_inspect_row__drop_hint_bog_vmap_app_inspect_38 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['row_drop_hint'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['drop_hint'] >
	>
	type $bog_vmap_app_inspect_row__owner_bog_vmap_app_inspect_39 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['row_owner'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['owner'] >
	>
	type $bog_vmap_app_inspect_row__inherited_bog_vmap_app_inspect_40 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['row_inherited'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['inherited'] >
	>
	type $bog_vmap_app_inspect_row__value_bog_vmap_app_inspect_41 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['row_value'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['value'] >
	>
	type $bog_vmap_app_inspect_row__keyed_bog_vmap_app_inspect_42 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['row_keyed'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['keyed'] >
	>
	type $bog_vmap_app_inspect_row__changeable_bog_vmap_app_inspect_43 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['row_changeable'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['changeable'] >
	>
	type $bog_vmap_app_inspect_row__drop_bog_vmap_app_inspect_44 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['row_drop'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['drop'] >
	>
	type $bog_vmap_app_inspect_row__frozen_bog_vmap_app_inspect_45 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['row_frozen'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['frozen'] >
	>
	type $bog_vmap_app_inspect_row__note_bog_vmap_app_inspect_46 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['row_note'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['note'] >
	>
	type $bog_vmap_app_inspect_row__share_able_bog_vmap_app_inspect_47 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['share_able'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['share_able'] >
	>
	type $bog_vmap_app_inspect_row__share_mark_bog_vmap_app_inspect_48 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['share_mark'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['share_mark'] >
	>
	type $bog_vmap_app_inspect_row__share_bog_vmap_app_inspect_49 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['share'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['share'] >
	>
	type $bog_vmap_app_inspect_row__share_unshare_bog_vmap_app_inspect_50 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['share_unshare'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['share_unshare'] >
	>
	type $bog_vmap_app_inspect_row__binds_bog_vmap_app_inspect_51 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['binds'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['binds'] >
	>
	type $bog_vmap_app_inspect_row__nodes_bog_vmap_app_inspect_52 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['nodes'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['nodes'] >
	>
	type $bog_vmap_app_inspect_row__editable_bog_vmap_app_inspect_53 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect['editable'] >
		,
		ReturnType< $bog_vmap_app_inspect_row['editable'] >
	>
	export class $bog_vmap_app_inspect extends $mol_page {
		title_value( next?: string ): string
		title_submit( next?: any ): any
		Name( ): $mol_string
		base_submit( next?: any ): any
		base_pick( ): any
		total( ): string
		Note( ): $mol_status
		rows( ): readonly($mol_view)[]
		Rows( ): $mol_list
		shares_shown( next?: boolean ): boolean
		share_rows( ): readonly($mol_view)[]
		Shares( ): $mol_expander
		layout_shown( next?: boolean ): boolean
		flex_value( id: any, next?: string ): string
		Flex( ): $bog_vmap_app_inspect_flex
		Layout( ): $mol_expander
		inherited_shown( next?: boolean ): boolean
		inherited_rows( ): readonly($mol_view)[]
		Inherited( ): $mol_expander
		empty_note( ): string
		classes( ): readonly(any)[]
		share_row_name( id: any): string
		share_uses( id: any): string
		share_value( id: any, next?: $mol_tree2_empty ): $mol_tree2_empty
		Share_value( id: any): $bog_vmap_app_inspect_value
		row_sign( id: any): string
		row_drop_hint( id: any): string
		row_owner( id: any): string
		row_inherited( id: any): boolean
		row_value( id: any, next?: $mol_tree2_empty ): $mol_tree2_empty
		row_keyed( id: any, next?: boolean ): boolean
		row_changeable( id: any, next?: boolean ): boolean
		row_drop( id: any, next?: any ): any
		row_frozen( id: any): string
		row_note( id: any): string
		binds( ): readonly(string)[]
		nodes( ): Record<string, any>
		source( next?: string ): string
		peers( ): readonly($mol_tree2)[]
		pack( next?: string ): string
		class_title( next?: string ): string
		title_note( ): string
		editable( ): boolean
		renamable( ): ReturnType< $bog_vmap_app_inspect['editable'] >
		title( ): ReturnType< $bog_vmap_app_inspect['class_title'] >
		title_content( ): readonly(any)[]
		base( next?: string ): string
		bases( ): readonly(string)[]
		base_titles( ): Record<string, any>
		Base( ): $mol_select
		tools( ): readonly($mol_view_content)[]
		body( ): readonly($mol_view)[]
		cell( id: any, next?: any ): any
		frozen_note( ): string
		sub_note( ): string
		Empty( ): $mol_status
		Node( ): $bog_vmap_lang_node
		Lib( ): $bog_vmap_lib
		resettable( id: any): boolean
		reset( id: any, next?: any ): any
		share_able( id: any): boolean
		share_mark( id: any): string
		share( id: any, next?: any ): any
		share_unshare( id: any, next?: any ): any
		shares( ): readonly(string)[]
		Share_row( id: any): $mol_form_field
		Row( id: any): $bog_vmap_app_inspect_row
	}
	
	type $mol_select__hint_bog_vmap_app_inspect_demo_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_bog_vmap_app_inspect_demo_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_demo['klass'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_vmap_app_inspect_demo_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_demo['names'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $bog_vmap_app_inspect_value_area__rows_bog_vmap_app_inspect_demo_4 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_vmap_app_inspect_value_area['rows'] >
	>
	type $bog_vmap_app_inspect_value_area__value_bog_vmap_app_inspect_demo_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_demo['source'] >
		,
		ReturnType< $bog_vmap_app_inspect_value_area['value'] >
	>
	type $mol_page__title_bog_vmap_app_inspect_demo_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_vmap_app_inspect_demo_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_vmap_app_inspect_demo_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $bog_vmap_app_inspect__source_bog_vmap_app_inspect_demo_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_demo['class_source'] >
		,
		ReturnType< $bog_vmap_app_inspect['source'] >
	>
	type $bog_vmap_app_inspect__peers_bog_vmap_app_inspect_demo_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_demo['trees'] >
		,
		ReturnType< $bog_vmap_app_inspect['peers'] >
	>
	type $bog_vmap_lang_doc__source_bog_vmap_app_inspect_demo_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_demo['source'] >
		,
		ReturnType< $bog_vmap_lang_doc['source'] >
	>
	export class $bog_vmap_app_inspect_demo extends $mol_book2 {
		klass( next?: string ): string
		names( ): readonly(string)[]
		Class_pick( ): $mol_select
		Source_text( ): $bog_vmap_app_inspect_value_area
		Source( ): $mol_page
		class_source( next?: string ): string
		trees( ): readonly($mol_tree2)[]
		Inspect( ): $bog_vmap_app_inspect
		source( next?: string ): string
		pages( ): readonly(any)[]
		Doc( ): $bog_vmap_lang_doc
	}
	
}

//# sourceMappingURL=inspect.view.tree.d.ts.map